import React from "react";
import {
  Box,
  Stack,
  CircularProgress
} from "@mui/material";
import { Drawer, StageGateCard } from "../../../shared/components";
import { useStageGate } from "../../projectOverview/hooks/useStageGate";
import { useParams, useSearchParams } from "react-router-dom";
import { StageGateDetails, StageGateHeader } from "../components/StageGateDetails";

export const StageGates: React.FC = () => {

  const { projectId } = useParams<{ projectId: string }>();
  const { isFetching, stageGateData, refetch } = useStageGate(projectId);

  const [searchParams, setSearchParams] = useSearchParams();

  const selected = searchParams.get("selected");
  const gateId = searchParams.get("id");

  const openDrawer = ({ id }: { id: number }) => {
    const params = new URLSearchParams(searchParams);
    params.set("selected", "true");
    params.set("id", String(id));
    setSearchParams(params, { replace: true });
  }

  const closeDrawer = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("selected");
    params.delete("id");
    setSearchParams(params, { replace: true });
  }

  if (isFetching) {
    return (
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        gap={2}
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box p={2}>
      <Stack spacing={2}>
        {stageGateData.map(
          (
            gate: {
              id: number;
              name: string;
              description: string;
              owner: string;
              due_date: string;
              status_display_text: string;
              status: string;
              checklist: {
                completed: number;
                total: number;
                percent: number;
              };
              approval: { completed: number; total: number; percent: number };
              artefacts: {
                completed: number;
                total: number;
                percent: number;
              };
              color: string;
            },
            index: number,
          ) => (
            <StageGateCard
              key={index}
              name={gate.name}
              description={gate.description}
              owner={gate.owner}
              due_date={gate.due_date}
              status_display_text={gate.status_display_text}
              status={gate.status}
              checklist={gate.checklist}
              approval={gate.approval}
              artefacts={gate.artefacts}
              color={gate.color}
              onOpen={() => {
                openDrawer({ id: gate.id });
              }}
            />
          ),
        )}
      </Stack>

      <Drawer
        isOpen={!!selected}
        header={
          <StageGateHeader
            id={Number(gateId)}
            onClose={closeDrawer}
          />
        }
        children={
          <StageGateDetails
            refetch={refetch}
            projectId={projectId}
            id={Number(gateId)}
          />
        }
      />
    </Box>
  );
}